var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWalletDArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 28,
    viewBox: "0 0 91 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.9648 25L85.9648 27.8868L85.9648 22.1132L90.9648 25ZM13.0701 1L13.0701 0.500001L13.5701 0.500001L13.5701 1L13.0701 1ZM13.0701 25L13.0701 25.5L12.5701 25.5L12.5701 25L13.0701 25ZM0.964844 0.5L13.0701 0.500001L13.0701 1.5L0.964844 1.5L0.964844 0.5ZM13.5701 1L13.5701 25L12.5701 25L12.5701 1L13.5701 1ZM13.0701 24.5L86.4648 24.5L86.4648 25.5L13.0701 25.5L13.0701 24.5Z",
    fill: "#82993C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWalletDArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_wallet_d_arrow.810c7f65b7b11d64c850996191cf3967.svg";